import { useTranslation } from 'react-i18next';
import { siteConfig } from '../siteConfig';
import { navigate } from '../router';
import { Divider } from '../components/Divider';
import './Gift.css';

export function Gift() {
  const { t } = useTranslation();
  return (
    <section id={siteConfig.sections.gift.anchor} className="section gift">
      <Divider />
      <div className="section-header">
        <div className="section-kicker">{t('gift.kicker')}</div>
        <h2 className="section-title">{t('gift.title')}</h2>
      </div>
      <p className="gift__intro">{t('gift.intro')}</p>
      <a
        href={siteConfig.pages.shop.path}
        className="btn"
        onClick={(e) => {
          e.preventDefault();
          navigate(siteConfig.pages.shop.path);
        }}
      >
        {t('gift.cta')}
      </a>
    </section>
  );
}
